import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import { getToken, logOut } from '@/auth/auth';
import PlantList from '@/views/Plants.vue';
import PlantView from '@/views/Plant.vue';

const Login = () => import('@/views/auth/Login.vue');
const Authenticated = () => import('@/views/auth/Authenticated.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // Auth
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/authenticated',
      name: 'Authenticated',
      component: Authenticated,
      props: route => ({ code: route.query.code })
    },
    {
      path: '/logout',
      name: 'Logout',
      redirect: { name: 'Login' }
    },
    // App
    {
      path: '/plants',
      name: 'PlantList',
      component: PlantList
    },
    {
      path: '/plants/:id',
      name: 'PlantView',
      component: PlantView,
      props: route => ({ id: route.params.id })
    },
    {
      path: '*',
      name: 'NotFoundRoute',
      component: PlantList
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // Authentication check
  if (
    (to.name && ['Login', 'Authenticated'].includes(to.name)) || // Always allow certain routes
    (await getToken()) // Check for the token presence and validity
  ) {
    store.dispatch('app/setRouteLoading', true);
    next();
    return;
  }

  logOut(to);
  router.push({ name: 'Login' });
});

router.afterEach(() => {
  store.dispatch('app/setRouteLoading', false);
});

export default router;
